<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.motivo"
        ref="RkmDataTable"
        sort-by="descricao"
        search-by="descricao"
    >

        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-ponto"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    v-if="!item.bloqueado"
                    @click="handleBlock(item.id, false)"
                    color="dark"
                    small
                    title="Inativar"
                    autorize="update-transporte-paciente-ponto"
                >
                    <rkm-icon icon="ban"/>
                </rkm-button>

                <rkm-button
                    v-else
                    @click="handleBlock(item.id, true)"
                    color="success"
                    small
                    title="Ativar"
                    autorize="update-transporte-paciente-ponto"
                >
                    <rkm-icon icon="check-circle"/>
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-ponto"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>

                <slot
                    name="actions"
                    :destino="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase} from '@/mixins';

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'grupo',
                    label: 'Grupo',
                    name: 'transportePacienteGrupo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    name: 'transportePacienteMotivoViagemProcedimento.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'procedimento',
                    label: 'Procedimento',
                    name: 'sigtap.procedimento.codigo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'modulo',
                    label: 'Módulo',
                    name: 'transportePacienteMotivoModulo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'regulada',
                    label: 'Regulada',
                    name: 'transportePacienteMotivoViagemProcedimento.regulada',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'transportePacienteMotivoViagemProcedimento.bloqueado',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ];
        }
    },
    created() {
        this.repositories = {
            motivo: this.getConectaSusRepository('transportePaciente.motivo')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-motivo-edit', params: { id: id } })
        },
        handleBlock(id, ativar) {

            const bloqueio = () => this.repositories.motivo.bloquear(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showConfirmation(
                `Deseja realmente ${ativar ? 'ativar' : 'inativar'} o Motivo de viagem / Procedimento?`,
                bloqueio,
                null,
                this.handleError
            )
        },
        handleDestroy(id) {
            const exclusao = () => this.repositories.motivo.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation(
                'Deseja realmente excluir o Motivo de viagem / Procedimento?',
                exclusao,
                this.handleError
            )
        },
    },
    mixins: [ error, repository, stringCase ],
};
</script>